import React from 'react';
import { ButtonSecondary } from '@spotify-internal/encore-web';

import { useTranslation } from 'providers/translations/TranslationProvider';

interface HelpfulPollProps {
  onYesClick: () => void;
  onNoClick: () => void;
}
const HelpfulPoll = ({ onYesClick, onNoClick }: HelpfulPollProps) => {
  const { t } = useTranslation();

  return (
    <>
      <ButtonSecondary buttonSize="sm" onClick={onYesClick}>
        {t('yes')}
      </ButtonSecondary>{' '}
      <ButtonSecondary buttonSize="sm" onClick={onNoClick}>
        {/* {t('no_more_help')}*/}
        No, I need more help
      </ButtonSecondary>
    </>
  );
};
export default HelpfulPoll;
